import { render, staticRenderFns } from "./AlarmListNew.vue?vue&type=template&id=44df4424"
import script from "./AlarmListNew.vue?vue&type=script&lang=js"
export * from "./AlarmListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports